import { render, staticRenderFns } from "./gestaoLicencaPremio.vue?vue&type=template&id=0b65945c&scoped=true&"
import script from "./gestaoLicencaPremio.vue?vue&type=script&lang=js&"
export * from "./gestaoLicencaPremio.vue?vue&type=script&lang=js&"
import style0 from "./gestaoLicencaPremio.vue?vue&type=style&index=0&id=0b65945c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b65945c",
  null
  
)

export default component.exports